<div class="flex justify-content-center align-items-center min-h-screen surface-ground">
    <div class="p-card flex flex-column align-items-center p-5 text-center shadow-3 border-round-xl">
        <img src="../../assets/img/static/backupEnCurso.jpg" alt="Backup en curso..." style="max-width: 300px">
        <h1 class="mt-4 mb-2">Backup en curso...</h1>
        <h5 class="text-color-secondary mt-0 mb-4">Por favor intente nuevamente en unos minutos.</h5>
        <p-button label="Intentar nuevamente" (onClick)="tryAgain()"></p-button>
    </div>
</div>